import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
const Management = () => {
  useEffect(() => {
    document.title = "Management -  Mary Matha Cmi  Academy";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> School </li>
          <li>Management </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Management </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <p>
                Mary Matha CMI Academy is a catholic educational initiative, run
                by CMI Fathers in Kottayam Province, under Mary Matha
                Educational and Charitable society. St.Kuriakose Elias Chavara,
                a great visionary and revolutionary,
                <b>
                  founded the first catholic school of Kerala at Mannanam in
                  1846
                </b>
                . St.Chavara, in his capacity as the Vicar General of the Syro
                Malabar Church, ordered all parishes to start schools adjacent
                to them. This paved way for the emergence of educational
                institutions all over the state. Mary Matha CMI Academy was
                started in the year 2025, with its renowned identity and the
                objective of creating a dynamic environment which triggers
                learning and facilities the teaching process. It is located in
                the wholesome area of
                <b>Theni district</b> and designed to address even the miniscule
                in addition to addressing the contemporary needs of the pupils
                within a short span of time, the school has carved a niche for
                itself and counted among the
                <b>Best Schools in Tamil Nadu</b>.
              </p>
            </div>
          </div>

          {/* Image Section */}
          <div className="manage row mt-4  justify-content-between">
            <div className="col-lg-3 col-md-6 col-12  text-center">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/fr-robins-jacob.jpg"
                className="img-fluid"
                alt="Fr. Robins Jacob CMI"
              />
              <h5>Fr. Robins Jacob CMI</h5>
              <p>Correspondent and Manager</p>
            </div>

            <div className="col-lg-3 col-md-6 col-12 text-center">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/fr-sinu-m-joseph.jpg"
                className="img-fluid"
                alt="Fr. Sinu M Joseph CMI"
              />
              <h5>Fr. Sinu M Joseph CMI</h5>
              <p>Secretary</p>
            </div>

            <div className="col-lg-3 col-md-6 col-12  text-center">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/fr-jojo-mattathil.jpg"
                className="img-fluid"
                alt="Fr. Jojo Mattathil CMI"
              />
              <h5>Fr. Jojo Mattathil CMI</h5>
              <p>Financial Administrator</p>
            </div>

            <div className="col-lg-3 col-md-6 col-12  text-center">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/fr-jimmy-george.jpg"
                className="img-fluid"
                alt="Fr. Jimmy George CMI"
              />
              <h5>Fr. Jimmy George CMI</h5>
              <p>Director</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Management;
